import 'react-app-polyfill/ie11';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Routewrapper } from './route/index';
import './styles/index.css';
import './styles/toast-styles.css';
import './styles/responsive.css';
/// import { PublicClientApplication } from "@azure/msal-browser";
/// import { MsalProvider } from "@azure/msal-react";
/// import { msalConfig } from "./services/authConfig";
import './services/i18n';
import flagsmith from "flagsmith";
import { FlagsmithProvider } from 'flagsmith/react';
import { getRuntimeConfig } from './utils/runtimeConfig';
//redux imports
import { Provider } from 'react-redux';
import store from './redux/store';

// interceptors for all request and reponse
import('./services/api.interceptors').then(({ executeInterceptors }) => executeInterceptors());

/// const msalInstance = new PublicClientApplication(msalConfig);

// Get Flagsmith environment ID from runtime config or build-time env
const flagsmithEnvironmentID = getRuntimeConfig('REACT_APP_FLAGS_ENVIRONMENT_ID', process.env.REACT_APP_FLAGS_ENVIRONMENT_ID);

ReactDOM.render(

  /// <Provider store={store}>
  ///   <MsalProvider instance={msalInstance}>
  ///     <Routewrapper />
  ///   </MsalProvider>
  /// </Provider>,
  <Provider store={store}>
      <FlagsmithProvider
      options={{
        environmentID: flagsmithEnvironmentID,
      }}
      flagsmith={flagsmith}>
        <Routewrapper />
      </FlagsmithProvider>
  </Provider>,
  document.getElementById('root')
);
